import './index.css'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/browser'
import packageJson from '../package.json'

/**
 * bundle 기준 0.8MB 가 늘어날 정도로 과한 처리입니다.
 * babel 설정을 통해 사용하는 내용만 포함되도록 정상처리 될 경우 제거합니다.
 */
import 'core-js/stable'
import App from './App'
import * as serviceWorker from './serviceWorker'
import store from './store'

const appVersion = packageJson?.version ?? 'default'

try {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: (process.env.REACT_APP_ENV ?? '').toLowerCase(),
    release: `land-web@${appVersion}`,
  })
} catch (e) {
  console.error('Sentry initialization failed.')
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
